import AdminNavbar from '../components/AdminNavbar';
import { useSelector } from 'react-redux';

export default function ({ children }) {
    const { role, token } = useSelector(state => state.userInfo);

    return role ? (
        <div className={'flex flex-col  gap-[40px] pb-[50px] md:h-screen'}>
            {token && role === 'Manager' && (
                <div className="px-[60px]">
                    <AdminNavbar />
                </div>
            )}
            {children}
        </div>
    ) : (
        <>{children}</>
    );
}
